import './nav.css'
import '../App.css'
import { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faGem, faFaceGrin, faGear, faWallet, faBoxOpen, faBarcode } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useLocation, matchPath } from 'react-router-dom';
import { handleVibration } from '../Pages/common/function';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import i18n from '../lang/i18n';
import axios from 'axios';
import { changeBanner, changeEnergy, checkDuplicateLogins } from '../store';

function Footer() {
    const { t } = useTranslation();
    const haptic = useSelector((state) => { return state.haptic.value })
    const shoppingState = useSelector((state) => { return state.shoppingState.value })
    const shoppingFlag = useSelector((state) => state.shoppingFlag.value);
    const Languages = useSelector((state) => state.Languages.value);
    const JWT = useSelector((state) => { return state.JWT.value })

    const energy = useSelector((state) => { return state.energy.value })
    const limitUpgradeValue = useSelector((state) => { return state.limitUpgradeValue.value })
    const PlusEnergy = useSelector((state) => { return state.PlusEnergy })

    const [btn, setBtn] = useState(0)
    let location = useLocation()
    let navigate = useNavigate()
    let dispatch = useDispatch()

    const [preparing, setPreparing] = useState(false)

    useEffect(() => {
        const path = location.pathname;

        if (path == "/") setBtn(0)
        else if (path == "/character") setBtn(1)
        else if (path == "/airdrop") setBtn(2)
        else if (path == "/friends") setBtn(3)
        else if (
            matchPath("/coupons", path) ||
            matchPath("/couponsDetail/:couponId", path) ||
            matchPath("/couponsBarcode", path) ||
            matchPath("/shopping", path) ||
            matchPath("/shoppingDetail/:shoppingId", path) ||
            matchPath("/shoppingBuy/:shoppingId", path) ||
            matchPath("/shoppingHistory", path) ||
            matchPath("/categoriesList", path) ||
            matchPath("/brandsList", path)
        ) {
            setBtn(4);
        }
        else if (path == "/walletDisabled") setBtn(5)
        // else if (path == "/randomBox") setBtn(7)
        else setBtn(6)

        if (
            matchPath("/coupons", path) ||
            matchPath("/couponsDetail/:couponId", path) ||
            matchPath("/couponsBarcode", path) ||
            matchPath("/shopping", path) ||
            matchPath("/shoppingDetail/:shoppingId", path) ||
            matchPath("/shoppingBuy/:shoppingId", path) ||
            matchPath("/shoppingHistory", path) ||
            matchPath("/categoriesList", path) ||
            matchPath("/brandsList", path)
        ) {
            setBtn(4);
            if (shoppingFlag == "한국") {
                i18n.changeLanguage('ko-KR');
            } else {
                i18n.changeLanguage('en-US');
            }
        }
        else {
            i18n.changeLanguage(Languages);
        }
    }, [location, shoppingFlag])

    const onClickBtn = (e) => {
        if (haptic) handleVibration(1);
        navigate(e)
    }

    useEffect(() => {
        BannerData()
    }, [])

    const BannerData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/ad', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                dispatch(changeBanner(tmp?.data?.ad ?? []))
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const intervalRef = useRef(null);
    const nowEnergy = useRef(energy);

    useEffect(() => {
        nowEnergy.current = energy;

        if (energy < limitUpgradeValue && !intervalRef.current && PlusEnergy?.energy && PlusEnergy?.energyCycle) {
            startEnergyInterval();
        }
    }, [energy]);

    useEffect(() => {
        if (!PlusEnergy?.energy || !PlusEnergy?.energyCycle) return;

        // clean-up 함수
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [PlusEnergy, limitUpgradeValue]);

    function startEnergyInterval() {
        const energyToAdd = Number(PlusEnergy.energy);
        const cycle = Number(PlusEnergy.energyCycle);

        intervalRef.current = setInterval(() => {
            if (nowEnergy.current >= limitUpgradeValue) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                return;
            }

            const newEnergy = Math.min(nowEnergy.current + energyToAdd, limitUpgradeValue);
            nowEnergy.current = newEnergy;
            dispatch(changeEnergy(newEnergy));

            if (newEnergy >= limitUpgradeValue) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }, cycle);
    }

    return (
        <div className='footer'>
            <div className='footer-box'>
                <div className={`footer-box-1 ${btn === 0 ? "active" : ""}`}
                    onClick={() => onClickBtn('/')}>
                    <FontAwesomeIcon icon={faGem} fontSize={24} color={btn === 0 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_0')}</div>
                </div>
                <div className={`footer-box-1 ${btn === 1 ? "active" : ""}`}
                    onClick={() => onClickBtn('/character')}>
                    <FontAwesomeIcon icon={faFaceGrin} fontSize={24} color={btn === 1 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_1')}</div>
                </div>
                <div className={`footer-box-1 ${btn === 2 ? "active" : ""}`}
                    onClick={() => onClickBtn('/airdrop')}>
                    <img src='/img/saycoin.png' style={{ width: "24px", filter: btn === 2 ? "" : "grayscale(1)" }} />
                    <div>{t('footer_2')}</div>
                </div>
                <div className={`footer-box-1 ${btn === 3 ? "active" : ""}`}
                    onClick={() => onClickBtn('/friends')}>
                    <FontAwesomeIcon icon={faUsers} fontSize={24} color={btn === 3 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_3')}</div>
                </div>
                <div className={`footer-box-1 ${btn === 4 ? "active" : ""}`}
                    onClick={() => onClickBtn('/shopping')}>
                    <i className="fa-brands fa-shopify" style={{ fontSize: "24px", color: btn === 4 ? "#ffbb3f" : "#636363", marginBottom: "3px" }}></i>
                    {/* <FontAwesomeIcon icon={faBarcode} fontSize={24} color={btn === 4 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} /> */}
                    <div>{t('footer_7')}</div>
                </div>
                {/* <div className={`footer-box-1 ${btn === 4 ? "active" : ""}`}
                    onClick={() => onClickBtn('/randomBox')}>
                    <FontAwesomeIcon icon={faBoxOpen} fontSize={24} color={btn === 7 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_6')}</div>
                </div> */}
                <div className={`footer-box-1`}
                    onClick={() => preparing ? onClickBtn('/walletDisabled') : 
                    window.location.href = shoppingState ? 'https://dev.saypot.ttory.com/wallet' : 'https://saypot.ttory.com/wallet'}>
                    <FontAwesomeIcon icon={faWallet} fontSize={24} color={btn === 5 ? "#ffbb3f" : "#636363"} style={{ marginBottom: "3px", }} />
                    <div>{t('footer_5')}</div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
